import Vue from 'vue'
import App from '../components/flights/App.vue'

document.addEventListener('DOMContentLoaded', () => {
    const app = new Vue({
        render: h => h(App, {
            props: {
                title: title,
                filterText: filter_text,
                arrivalsText: arrivals_text,
                departuresText: departures_text
            }
        })
    }).$mount('#flights-app')
})